import { FC, useCallback } from "react"
import { useField, ErrorMessageProps } from "formik"
import {
  TextArea as MarmaladeTextArea,
  TextAreaProps as MarmaladeTextAreaProps
} from "@eventbrite/marmalade"

export type HandleChange = (
  value: string,
  name: string,
  event: React.ChangeEvent<HTMLTextAreaElement>
) => void

export interface Props extends MarmaladeTextAreaProps {
  name: string
  errorMessageProps?: ErrorMessageProps
}

export const TextArea: FC<Props> = ({
  name,
  label,
  helperText,
  id,
  ...otherProps
}) => {
  const [field, meta, helpers] = useField(name)

  const handleChange: HandleChange = useCallback(
    (value) => {
      if (!meta.touched) {
        helpers.setTouched(true, false)
      }

      helpers.setValue(value)
    },
    [helpers.setValue]
  )

  return (
    <>
      <MarmaladeTextArea
        {...field}
        {...otherProps}
        name={name}
        label={label}
        id={id}
        onChange={handleChange}
        value={field.value}
        hasError={meta?.touched && meta?.error ? true : false}
        helperText={meta?.error && meta?.touched ? meta?.error : helperText}
      />
    </>
  )
}
